// extracted by mini-css-extract-plugin
export var container = "_31-0";